<template>
    <div>
        <div v-if="$appUtils.isDesktop()" class="container-fluid-grid">
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th>Arquivo</th>
                            <th style="width: 100px">Tamanho</th>
                            <th style="width: 130px">Data</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="f in files"
                            :key="f.id" class="line-item">
                            <td class="ellipsis">
                                <a class="link-theme" href="javascript:void(0)" @click="download(f.id)">{{f.name}}</a>
                            </td>
                            <td class="ellipsis t-r">{{f.size_text}}</td>
                            <td class="ellipsis t-c p-r o-x-h" :title="f.distance">
                              {{f.created_at | formatDateHourMin}}


                              <div class="actions btn-group btn-group-xs">
                                <button type="button"
                                        class="btn btn-xs btn-danger"
                                        @click="destroy(f.id, $event)"
                                        title="Remover">
                                  <svg-icon icon="trash-alt"/>
                                </button>
                              </div>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else
             class="grid-mobile"
             v-for="f in files"
             :key="f.id">
            <span class="name ellipsis f-w-700">{{f.name}}</span>
            <span class="size">{{f.size_text}}</span>
            <span class="date">{{f.created_at | formatDateHourMin}}</span>


            <div class="act">
                <button type="button"
                        class="btn btn-sm"
                        title="Remover"
                        @click="download(f.id)">
                    <svg-icon icon="cloud-download-alt"/>
                </button>
            </div>
        </div>

        <div class="t-r" v-if="entity.id">
            <button type="button"
                    style="margin-right: 10px"
                    class="btn btn-sm btn-outline-primary"
                    @click="addFile"><svg-icon icon="plus"/> Adicionar</button>
        </div>

        <div ref="intersect" class="t-c refresh-container">
            <svg-icon icon="sync" svg-class="refresh load-more-crud" v-if="searching"/>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../utils/EventBus"
    const baseUrl = '/v1/customer_group_files'

    export default {
        name: "FilesTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                files: [],
                searching: false
            }
        },
        methods: {
            load() {
                if (this.entity.id){
                    this.searching = true;
                    this.$appHttp.get(`${baseUrl}/load_files/${this.entity.customer_group_id}`)
                        .then(({data}) => {
                            data.forEach(f => this.files.pushOrChange(f));

                            this.entity.group_files_count = this.files.length;
                            this.$emit('onUpdateTabBadges');
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao carregar os arquivos.'}), this.$appStorage.getUser().name);
                            console.error(err);
                        })
                        .finally(() => this.searching = false)
                }
            },
            addFile() {
                EventBus.showCustomerGroupFile(() => {
                    this.load();
                }, {customer_group_id: this.entity.customer_group_id, mode: 'block_customer_group'});
            },
            download(id) {
                this.$appHttp.get(`${baseUrl}/download/${id}`)
                    .then(({data}) => {
                        document.location.href = data.url;
                    })
                    .catch(console.error)
            },
            destroy(idItem, e) {
              e.preventDefault();
              e.cancelBubble = true;

              this.$store.commit('addModal', {title: this.$t('common.destroyItemTitle'), size: 'small', body: this.$t('common.destroyItemMessage'), buttons: [
                  {type: 'ok', class: 'btn btn-danger btn-sm', method: id => {
                      this.$store.commit('destroyModal', id);
                      this.$appHttp.delete(`${baseUrl}/destroy/${idItem}`)
                          .then(() => this.$set(this, 'files', this.files.filter(f => f.id !== idItem)))
                          .catch(console.error)
                          .finally(() => {
                            this.$set(this.entity, 'group_files_count', this.files.length)
                            this.$emit('onUpdateTabBadges');
                          })
                    }},
                  {type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)}
                ]})

            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style lang="scss" scoped>
    .refresh-container {
        svg {
            width: 2em;
            height: 2em;
        }
    }

    .grid-mobile {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'name name' 'size date' 'act act';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;
        font-size: .8em;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .name{
            grid-area: name;
        }
        .size{
            grid-area: size;
        }
        .date{
            grid-area: date;
            text-align: right;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
